module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-icons",
    staticStyle: {
      "display": "none"
    }
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "select-arrow",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M120 30.5L76.8 82.3c-9.5 9.5-24.2 9.5-33.7 0L0 30.5h120z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "add",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M116.9 56.9H63.1V3.1C63.1 1.4 61.7 0 60 0s-3.1 1.4-3.1 3.1v53.8H3.1C1.4 56.9 0 58.3 0 60c0 1.7 1.4 3.1 3.1 3.1h53.8v53.8c0 1.7 1.4 3.1 3.1 3.1s3.1-1.4 3.1-3.1V63.1h53.8c1.7 0 3.1-1.4 3.1-3.1 0-1.7-1.4-3.1-3.1-3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "arrow-head",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M3.8 25.8L60 94.2l56.2-68.4"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 98c-1.1 0-2.2-.5-2.9-1.4L.9 28.1c-1.3-1.6-1.1-4 .5-5.3 1.6-1.3 4-1.1 5.3.5l53.4 65 53.4-65c1.3-1.6 3.7-1.8 5.3-.5 1.6 1.3 1.8 3.7.5 5.3L62.9 96.6c-.7.9-1.8 1.4-2.9 1.4z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "calendar",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M43.8 77.7H22.4V56.3h21.4v21.4zM28.2 72h10.4V61.6H28.2V72zM70.4 77.7H49.6V56.3H71v21.4h-.6zM54.8 72h10.4V61.6H54.8V72zM97.6 77.7H76.2V56.3h21.4v21.4zM81.4 72h10.4V61.6H81.4V72zM43.8 104.3H22.4V83h21.4v21.3zm-15.6-5.2h10.4V88.7H28.2v10.4zM70.4 104.3H49.6V83H71v21.4h-.6zm-15.6-5.2h10.4V88.7H54.8v10.4zM97.6 104.3H76.2V83h21.4v21.3zm-16.2-5.2h10.4V88.7H81.4v10.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M99.1 10.4h-4.7V5.2c0-2.6-2.1-5.2-5.2-5.2H75.7c-2.6 0-5.2 2.1-5.2 5.2v5.2H49.6V5.2c0-2.6-2.1-5.2-5.2-5.2H30.8c-2.6 0-5.2 2.1-5.2 5.2v5.2h-4.2c-8.9 0-16.2 7.3-16.2 16.2v77.7c0 8.9 7.3 15.7 16.2 15.7h77.2c8.9 0 16.2-6.8 16.2-15.7V26.6c0-8.9-7.3-16.2-15.7-16.2zM76.2 5.2h13.6v21.3H76.2V5.2zm-45.4 0h13.6v21.3H30.8V5.2zm78.8 99.1c0 5.7-4.7 10.4-10.4 10.4H21.4c-5.7 0-10.4-4.7-10.4-10.4V42.8h98.6v61.5zm0-66.7H11v-11c0-5.7 4.7-10.4 10.4-10.4h4.2v10.4c0 2.6 2.1 5.2 5.2 5.2h13c3.1 0 5.7-2.1 5.7-5.2V16.2h20.9v10.4c0 2.6 2.1 5.2 5.2 5.2h13.6c3.1 0 5.7-2.1 5.2-5.2V16.2h4.7c5.7 0 10.4 4.7 10.4 10.4v11z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "delete",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M109.1 11.3H76.9V5.6c0-3.1-2.5-5.6-5.6-5.6H48.8c-3.1 0-5.6 2.5-5.6 5.6v5.7H10.9c-1.6 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8h5.2l3.6 92.9c.2 5.7 4.9 10.1 10.5 10.1h59.5c5.7 0 10.3-4.5 10.5-10.1l3.6-92.9h5.2c1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.7-2.8zM48.8 5.6h22.4v5.6H48.8V5.6zm45.9 104c-.1 2.6-2.3 4.7-4.9 4.7H30.3c-2.6 0-4.8-2.1-4.9-4.7l-3.6-92.7h76.4l-3.5 92.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42.8 42.6c0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.9l.9 46.1c0 1.5 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.9l-.9-46.1zM60 39.8c-1.6 0-2.8 1.3-2.8 2.8v46.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8V42.6c0-1.6-1.2-2.8-2.8-2.8zM80.1 39.8c-1.5 0-2.9 1.2-2.9 2.8l-.9 46.1c0 1.6 1.2 2.8 2.8 2.9 1.5 0 2.8-1.2 2.8-2.8l.9-46.1c.1-1.6-1.1-2.9-2.7-2.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "download",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M88.4 69.5c-1.2-1.3-3.2-1.5-4.6-.3L63.2 87.6v-84c0-1.8-1.4-3.2-3.2-3.2-1.8 0-3.2 1.4-3.2 3.2v84L36.1 69.2c-1.3-1.2-3.4-1.1-4.6.3-1.2 1.3-1.1 3.4.3 4.6L55 94.8c2.8 2.5 7.1 2.5 9.9 0L88.2 74c.7-.6 1.1-1.5 1.1-2.4 0-.7-.3-1.5-.9-2.1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.5 119.6h-75C10.1 119.6 0 109.5 0 97.1V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c0 8.8 7.2 16 16 16h75.1c8.8 0 16-7.2 16-16V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c.1 12.3-10 22.4-22.4 22.4z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "formula",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M30.4 120L16.7 69.4H5c-2.4 0-4.3-1.9-4.3-4.3s1.9-4.3 4.3-4.3h18.2l7.7 28.4L58.4 0H115c2.4 0 4.3 1.9 4.3 4.3s-1.9 4.3-4.3 4.3H64.8L30.4 120z"
    }
  }), _c('path', {
    attrs: {
      "d": "M88.5 51.4l9.4-11.9c1.5-1.9 1.1-4.5-.7-6-1.9-1.5-4.5-1.1-6 .7l-8.1 10.3L75 34.2c-1.5-1.9-4.1-2.2-6-.7-1.9 1.5-2.2 4.1-.7 6l9.4 11.9-9.4 11.9c-1.5 1.9-1.1 4.5.7 6 .8.6 1.7.9 2.6.9 1.3 0 2.5-.6 3.4-1.6l8.1-10.3 8.1 10.3c.8 1.1 2.1 1.6 3.4 1.6.9 0 1.8-.3 2.6-.9 1.9-1.5 2.2-4.1.7-6l-9.4-11.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "info",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M60 0C26.8 0 0 26.8 0 60s26.8 60 60 60 60-26.8 60-60S93.2 0 60 0zm0 109.4c-26.8 0-49.4-21.9-49.4-49.4 0-26.8 21.9-49.4 49.4-49.4s49.4 21.9 49.4 49.4c0 26.8-22.6 49.4-49.4 49.4z"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 83.3c-4.2 0-7.1 3.5-7.1 7.1 0 4.2 3.5 7.1 7.1 7.1s7.1-3.5 7.1-7.1-2.9-7.1-7.1-7.1zM60 21.9c-11.3 0-19.8 9.2-19.8 19.8 0 2.8 2.1 5.6 5.6 5.6 2.8 0 5.6-2.1 5.6-5.6 0-4.9 4.2-9.2 9.2-9.2s9.2 4.2 9.2 9.2-4.2 9.2-9.2 9.2c-3.5 0-6.4 2.8-6.4 5.6v10.6c0 2.8 2.1 5.6 5.6 5.6s5.6-2.1 5.6-5.6v-5.6c8.5-2.1 14.8-9.9 14.8-19.1-.4-11.3-8.9-20.5-20.2-20.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "logo",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 400 53.8",
      "width": "400",
      "height": "54"
    }
  }, [_c('path', {
    attrs: {
      "d": "M26.4 0C11.8 0 0 11.8 0 26.4c0 14.5 11.8 26.4 26.4 26.4S52.8 41 52.8 26.4C52.7 11.8 40.9 0 26.4 0m0 44.8C16.2 44.8 8 36.5 8 26.4 8 16.2 16.2 8 26.4 8s18.4 8.3 18.4 18.4c0 10.1-8.2 18.4-18.4 18.4",
      "fill": "#4a89e5"
    }
  }), _c('path', {
    attrs: {
      "d": "M50.9 52.4c-1.6 1.4-4.1 1.3-5.6-.4L41 47c-1.4-1.6-1.3-4.1.4-5.6 1.6-1.4 4.1-1.3 5.6.4l4.3 5c1.4 1.6 1.2 4.2-.4 5.6",
      "fill": "#4a89e5"
    }
  }), _c('g', [_c('path', {
    attrs: {
      "d": "M108.1 41.9c0 .7-.3 1.2-.8 1.7s-1.2.7-1.8.7c-.5 0-.9-.1-1.3-.4-.4-.3-.7-.6-.9-1.1l-3.5-7.9H80.4L77 42.8c-.2.5-.5.9-.9 1.1-.4.3-.9.4-1.3.4-.7 0-1.3-.2-1.9-.7-.5-.5-.8-1-.8-1.7 0-.3.1-.6.3-1.1L87.1 8.3c.2-.6.6-1 1.2-1.3.5-.3 1.1-.5 1.7-.5s1.2.2 1.7.5.9.8 1.2 1.3l14.9 32.5c.2.5.3.8.3 1.1zM82.4 30.5h15.5L90.1 13l-7.7 17.5zM140.6 28.1c1.2 1.5 1.8 3.5 1.8 5.8 0 3.2-1.1 5.7-3.3 7.5-2.2 1.8-5.3 2.7-9.2 2.7h-13.4c-.8 0-1.5-.2-2-.7-.5-.5-.7-1.1-.7-1.9v-32c0-.8.2-1.5.7-1.9.5-.5 1.1-.7 2-.7h12.9c3.8 0 6.8.9 9 2.6 2.2 1.7 3.2 4.1 3.2 7.1 0 2-.5 3.7-1.6 5.1-1 1.4-2.5 2.5-4.4 3.2 2.1.6 3.8 1.6 5 3.2zM119 22.9h9.4c5.2 0 7.8-2 7.8-5.9 0-2-.6-3.4-1.9-4.4-1.3-.9-3.2-1.4-5.9-1.4H119v11.7zm16.2 15.3c1.3-1 1.9-2.5 1.9-4.6 0-2.1-.6-3.7-1.9-4.7-1.3-1-3.3-1.6-5.9-1.6H119v12.3h10.2c2.8 0 4.8-.4 6-1.4zM156.4 42.1c-2.6-1.5-4.7-3.7-6.1-6.6-1.4-2.9-2.1-6.3-2.1-10.2 0-3.9.7-7.2 2.1-10.1 1.4-2.9 3.4-5.1 6.1-6.6 2.6-1.5 5.7-2.3 9.3-2.3 2.3 0 4.5.4 6.6 1.1 2.1.7 3.9 1.8 5.4 3.1.7.5 1 1.2 1 2.1 0 .6-.2 1.2-.5 1.6-.4.4-.8.7-1.3.7-.6 0-1.2-.2-1.7-.7-1.7-1.3-3.2-2.2-4.6-2.7-1.4-.5-3-.8-4.7-.8-3.9 0-6.8 1.2-8.9 3.7-2.1 2.5-3.1 6.1-3.1 10.8 0 4.7 1 8.3 3.1 10.8s5 3.7 8.9 3.7c1.7 0 3.2-.3 4.6-.8 1.4-.5 3-1.4 4.7-2.6.7-.5 1.3-.7 1.7-.7.5 0 .9.2 1.3.7.4.4.5 1 .5 1.6 0 .9-.3 1.6-1 2.1-1.5 1.4-3.4 2.4-5.4 3.1-2.1.7-4.3 1.1-6.6 1.1-3.6.2-6.7-.5-9.3-2.1zM213.8 50.1c.3.5.5 1 .5 1.5 0 .6-.2 1.2-.7 1.6-.5.4-1.1.6-1.7.6-1.1 0-2-.5-2.7-1.6l-3.1-5.1c-1.1-1.8-3-2.7-5.5-2.7-3.5 0-6.6-.8-9.2-2.3-2.6-1.5-4.6-3.7-6-6.6-1.4-2.8-2.1-6.2-2.1-10.1 0-3.9.7-7.3 2.1-10.2 1.4-2.9 3.4-5.1 6-6.6s5.7-2.3 9.2-2.3c3.6 0 6.6.8 9.2 2.3 2.6 1.5 4.6 3.7 6 6.6 1.4 2.9 2.1 6.2 2.1 10.1 0 4.3-.9 8-2.6 11.1-1.8 3.1-4.2 5.3-7.4 6.6 1.5.5 2.8 1.7 4 3.5l1.9 3.6zm-21.9-13.9c2.1 2.5 4.9 3.8 8.6 3.8 3.7 0 6.6-1.3 8.7-3.8 2.1-2.5 3.1-6.1 3.1-10.8 0-4.7-1-8.3-3.1-10.8s-5-3.8-8.7-3.8c-3.7 0-6.6 1.3-8.6 3.8-2.1 2.5-3.1 6.1-3.1 10.8 0 4.7 1 8.3 3.1 10.8zM246.4 18.4c.5.5.7 1.1.7 1.9v21.5c0 .7-.2 1.3-.7 1.8-.5.5-1.1.7-2 .7-.7 0-1.3-.2-1.8-.7-.5-.4-.7-1-.7-1.8v-2c-.8 1.5-1.9 2.6-3.3 3.4-1.4.8-3 1.2-4.8 1.2-6.3 0-9.4-3.4-9.4-10.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.5.7 1.1.7 1.9V34c0 2.1.4 3.6 1.3 4.6.8 1 2.1 1.5 3.9 1.5 2.1 0 3.7-.7 5-2 1.2-1.3 1.9-3.1 1.9-5.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8.1 1.5.3 1.9.7zM273 20.2c1.7 1.7 2.5 4.3 2.5 7.9v13.7c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-1.9.7-.8 0-1.4-.2-1.8-.7-.5-.5-.7-1.1-.7-1.8v-2c-.7 1.5-1.7 2.6-3 3.4-1.3.8-2.9 1.2-4.6 1.2-1.7 0-3.2-.3-4.6-1-1.4-.7-2.5-1.6-3.3-2.9-.8-1.2-1.2-2.6-1.2-4.1 0-1.9.5-3.3 1.5-4.4 1-1.1 2.6-1.8 4.8-2.3 2.2-.5 5.3-.7 9.2-.7h1.2v-1.5c0-2-.4-3.4-1.2-4.3-.8-.9-2.1-1.3-3.9-1.3-1.2 0-2.4.2-3.5.5s-2.3.8-3.6 1.4c-.9.5-1.6.8-2 .8-.5 0-1-.2-1.3-.6-.3-.4-.5-.9-.5-1.5 0-.5.1-1 .4-1.4.3-.4.8-.8 1.5-1.2 1.2-.7 2.7-1.2 4.3-1.6 1.7-.4 3.3-.6 4.8-.6 3.4-.2 6 .7 7.6 2.4zm-4.5 18.3c1.2-1.3 1.8-3 1.8-5.1V32h-.9c-2.7 0-4.9.1-6.3.4-1.5.2-2.5.7-3.2 1.2-.6.6-.9 1.4-.9 2.5 0 1.3.5 2.3 1.4 3.1.9.8 2.1 1.2 3.4 1.2 1.9 0 3.5-.6 4.7-1.9zM305.9 28v13.7c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-2 .7-.8 0-1.5-.2-1.9-.7-.5-.5-.7-1.1-.7-1.8V28.3c0-2.2-.4-3.8-1.3-4.8s-2.2-1.5-4-1.5c-2.1 0-3.9.7-5.2 2-1.3 1.3-2 3.1-2 5.4v12.4c0 .8-.2 1.4-.7 1.8-.5.5-1.1.7-1.9.7-.8 0-1.5-.2-2-.7-.5-.5-.7-1.1-.7-1.8V20.3c0-.7.3-1.3.8-1.8s1.2-.7 1.9-.7c.8 0 1.4.2 1.8.7.5.5.7 1.1.7 1.8v2.2c.8-1.5 2-2.7 3.5-3.5 1.5-.8 3.2-1.2 5.1-1.2 6.2-.2 9.3 3.3 9.3 10.2zM327.5 40.8c.3.3.5.8.5 1.4 0 .7-.3 1.2-.8 1.6-.5.4-1.3.5-2.4.4l-1.4-.1c-2.8-.2-5-1.1-6.4-2.6-1.4-1.5-2.1-3.8-2.1-6.8V22.4h-3.2c-1.5 0-2.3-.7-2.3-2.1 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.7-.6h3.2v-5.4c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 1.9-.7s1.5.2 2 .7c.5.5.7 1.1.7 1.9v5.4h5.2c.7 0 1.3.2 1.7.6.4.4.6.9.6 1.5 0 .7-.2 1.2-.6 1.5-.4.4-1 .5-1.7.5h-5.2v12.8c0 1.7.3 2.9 1 3.6.7.8 1.7 1.2 3.1 1.3l1.5.1c.8.2 1.3.4 1.7.7zM353.7 18.4c.5.5.7 1.1.7 1.9v21.5c0 .7-.2 1.3-.7 1.8-.5.5-1.1.7-2 .7-.7 0-1.3-.2-1.8-.7-.5-.4-.7-1-.7-1.8v-2c-.8 1.5-1.9 2.6-3.3 3.4-1.4.8-3 1.2-4.8 1.2-6.3 0-9.4-3.4-9.4-10.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.8 0 1.5.2 1.9.7.5.5.7 1.1.7 1.9V34c0 2.1.4 3.6 1.3 4.6.8 1 2.1 1.5 3.9 1.5 2.1 0 3.7-.7 5-2 1.2-1.3 1.9-3.1 1.9-5.3V20.3c0-.8.2-1.4.7-1.9.5-.5 1.1-.7 2-.7.7.1 1.4.3 1.9.7zM400 28v13.7c0 .8-.2 1.4-.7 1.9s-1.1.7-2 .7c-.8 0-1.4-.2-1.9-.7s-.7-1.1-.7-1.9V28.1c0-2.1-.4-3.7-1.2-4.7-.8-1-2-1.5-3.6-1.5-1.9 0-3.5.7-4.6 2-1.1 1.3-1.7 3.1-1.7 5.4v12.4c0 .8-.2 1.4-.7 1.9-.5.4-1.1.7-2 .7-.8 0-1.4-.2-1.9-.7s-.7-1.1-.7-1.9V28.1c0-2.1-.4-3.7-1.2-4.7-.8-1-2-1.5-3.6-1.5-1.9 0-3.5.7-4.6 2s-1.7 3.1-1.7 5.4v12.4c0 .8-.2 1.4-.7 1.9s-1.1.7-1.9.7c-.8 0-1.4-.2-1.9-.7s-.8-1.1-.8-1.9V20.3c0-.8.3-1.4.8-1.8.5-.5 1.2-.7 1.9-.7s1.3.2 1.8.7c.5.4.7 1 .7 1.8v2c.8-1.5 1.8-2.6 3.2-3.4 1.4-.8 3-1.2 4.7-1.2 2 0 3.6.4 4.9 1.2 1.3.8 2.2 2.1 2.9 3.7.8-1.5 1.9-2.7 3.4-3.6 1.5-.9 3.2-1.3 5.2-1.3 5.7-.1 8.6 3.4 8.6 10.3z"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "bc-logo",
      "viewBox": "0 0 185 52",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9.3 31.8h-9V.5C4.1.3 6.9.2 8.6.2c3.1 0 5.5.7 7.2 2 1.7 1.3 2.6 3.2 2.6 5.7 0 1.5-.5 2.8-1.6 4-1.1 1.2-2.3 1.9-3.6 2.2 2.5.6 4.3 1.6 5.4 3 1.1 1.4 1.7 3.3 1.7 5.6 0 2.8-1 4.9-3 6.6-2.1 1.7-4.7 2.5-8 2.5zM4.6 4v9c.9.1 2 .1 3.4.1 4.1 0 6.1-1.6 6.1-4.9 0-2.9-1.9-4.3-5.6-4.3-1.3-.1-2.6-.1-3.9.1zm0 12.3v11.9c1.5.1 2.6.2 3.4.2 2.7 0 4.7-.5 5.9-1.5 1.2-1 1.9-2.6 1.9-4.8 0-2-.6-3.5-1.8-4.5-1.2-1-3.2-1.5-5.9-1.5 0 .1-3.5.2-3.5.2zM45.4 1.7L44 5.3c-1.4-1-3.5-1.5-6.5-1.5-2.8 0-5 1.2-6.7 3.5s-2.5 5.4-2.5 9.1c0 3.6.9 6.5 2.6 8.7 1.7 2.2 3.9 3.3 6.6 3.3 3 0 5.2-1 6.8-3.1l2.4 3.3c-2.5 2.5-5.7 3.7-9.6 3.7-4.1 0-7.4-1.5-9.7-4.4-2.4-2.9-3.5-6.8-3.5-11.7 0-4.7 1.3-8.6 3.8-11.6C30.1 1.5 33.3 0 37.3 0c3.4 0 6.1.6 8.1 1.7zm19.4 30.1V.5h4.3V28h14.2v3.8H64.8zM91.4 4.4v8.7h10.4v3.6H91.4V28h14.3v3.8H87.1V.5H106v3.8H91.4zm41.1-1.7l-1.8 3.5c-2.2-1.6-4.3-2.4-6.4-2.4-3.3 0-5.9 1.2-7.8 3.5-1.9 2.3-2.9 5.4-2.9 9.2 0 3.6.9 6.5 2.8 8.7 1.9 2.2 4.4 3.3 7.6 3.3 2.3 0 4.1-.7 5.6-2.1v-7.3h-4.4v-3.6h8.7v13.6c-1.1 1-2.7 1.7-4.8 2.3-2 .6-4 .9-6 .9-4.3 0-7.8-1.5-10.3-4.4-2.5-2.9-3.8-6.8-3.8-11.7 0-4.8 1.4-8.8 4.1-11.8 2.8-3 6.5-4.5 11.2-4.5 3.5.1 6.2 1 8.2 2.8zm25.9 29.1l-2.2-6.6h-11.7l-2.3 6.6h-4.8L150.2.1h1.1l11.9 31.7h-4.8zm-7.9-23.5l-4.9 13.8h9.4l-4.5-13.8zm16 23.5V.5h4.3V28H185v3.8h-18.5z",
      "fill": "#5b6d83"
    }
  }), _c('path', {
    attrs: {
      "d": "M3 51.8H0V41.4c1.3-.1 2.2-.1 2.8-.1 1 0 1.8.2 2.4.7.5.4.8 1 .8 1.9 0 .5-.2.9-.5 1.3-.4.4-.8.6-1.2.8.8.2 1.4.5 1.8 1 .4.5.6 1.1.6 1.9 0 .9-.3 1.7-1 2.2-.7.4-1.6.7-2.7.7zm-1.6-9.3v3h1.1c1.4 0 2-.5 2-1.7 0-1-.6-1.4-1.9-1.4-.4.1-.8.1-1.2.1zm0 4.1v4c.5 0 .9.1 1.1.1.9 0 1.5-.2 2-.5.4-.3.6-.9.6-1.6 0-.7-.2-1.2-.6-1.5-.4-.3-1.1-.5-2-.5H1.4zm17.2 5.2l-2.8-4.5c-.3 0-.8 0-1.5-.1v4.6h-1.4V41.4c.1 0 .4 0 1.1-.1.5 0 1 0 1.5-.1 2.5 0 3.8 1 3.8 3 0 .7-.2 1.2-.6 1.8-.4.5-.9.9-1.5 1l3 4.8h-1.6zm-4.4-9.1V46c.3 0 .7.1 1 .1.9 0 1.5-.1 1.9-.4.4-.3.6-.8.6-1.5 0-.6-.2-1-.6-1.3-.4-.3-1.1-.4-2-.4-.3.1-.6.1-.9.2zm11.7 9.1V41.4h1.4v10.4h-1.4zM41 52l-5.4-7.6v7.5h-1.4V41.4h.6l5.3 7.2v-7.2h1.4V52H41zm14.3-9.9l-.6 1.2c-.7-.5-1.4-.8-2.1-.8-1.1 0-2 .4-2.6 1.2-.6.8-1 1.8-1 3.1 0 1.2.3 2.2.9 2.9.6.7 1.5 1.1 2.6 1.1.8 0 1.4-.2 1.9-.7v-2.4h-1.5v-1.2h2.9V51c-.4.3-.9.6-1.6.8-.6.2-1.3.3-2 .3-1.5 0-2.6-.5-3.4-1.5-.8-1-1.3-2.3-1.3-3.9s.5-2.9 1.4-3.9c.9-1 2.2-1.5 3.7-1.5 1.1-.1 2 .2 2.7.8zm7.3 9.7V41.4H64v10.4h-1.4zm15 .2l-5.4-7.6v7.5h-1.4V41.4h.6l5.3 7.2v-7.2h1.4V52h-.5zm14.3-9.9l-.6 1.2c-.7-.5-1.4-.8-2.1-.8-1.1 0-2 .4-2.6 1.2-.6.8-1 1.8-1 3.1 0 1.2.3 2.2.9 2.9.6.7 1.5 1.1 2.6 1.1.8 0 1.4-.2 1.9-.7v-2.4h-1.5v-1.2h2.9V51c-.4.3-.9.6-1.6.8-.6.2-1.3.3-2 .3-1.5 0-2.6-.5-3.4-1.5-.8-1-1.3-2.3-1.3-3.9s.5-2.9 1.4-3.9c.9-1 2.2-1.5 3.7-1.5 1.1-.1 2 .2 2.7.8zm22.6-.3L114 43c-.5-.3-1.2-.5-2.2-.5-.9 0-1.7.4-2.2 1.2-.6.8-.8 1.8-.8 3s.3 2.2.9 2.9 1.3 1.1 2.2 1.1c1 0 1.7-.3 2.3-1l.8 1.1c-.8.8-1.9 1.2-3.2 1.2-1.4 0-2.5-.5-3.2-1.5-.8-1-1.2-2.3-1.2-3.9s.4-2.8 1.3-3.9c.8-1 1.9-1.5 3.3-1.5 1 0 1.9.2 2.5.6zm6.5 10V41.4h1.4v9.1h4.7v1.3H121zm16.5 0l-.7-2.2h-3.9l-.8 2.2h-1.6l4.3-10.6h.4l4 10.6h-1.7zm-2.6-7.8l-1.6 4.6h3.1l-1.5-4.6zm14.7 7.8l-2.8-4.5c-.3 0-.8 0-1.5-.1v4.6h-1.4V41.4c.1 0 .4 0 1.1-.1.5 0 1 0 1.5-.1 2.5 0 3.8 1 3.8 3 0 .7-.2 1.2-.6 1.8-.4.5-.9.9-1.4 1l3 4.8h-1.7zm-4.3-9.1V46c.3 0 .7.1 1 .1.9 0 1.5-.1 1.9-.4.4-.3.6-.8.6-1.5 0-.6-.2-1-.6-1.3-.4-.3-1.1-.4-2-.4-.2.1-.5.1-.9.2zm11.7 9.1V41.4h1.4v10.4H157zm11.8-9.1v9.1h-1.4v-9.2H164v-1.3h8.3v1.3h-3.5v.1zm12.4 4.4v4.7h-1.4v-4.7l-3.4-5.8h1.5l2.6 4.6 2.6-4.6h1.5l-3.4 5.8z",
      "fill": "#2e3234"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "minus",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M116.9 63.1H3.1C1.4 63.1 0 61.7 0 60c0-1.7 1.4-3.1 3.1-3.1h113.8c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "minus-large",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M5.5 60h109M114.5 65.5H5.5C2.4 65.5 0 63 0 60s2.4-5.5 5.5-5.5h109.1c3 0 5.5 2.4 5.5 5.5s-2.5 5.5-5.6 5.5z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "save",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.7 0H1.3v120h117.5V21L97.7 0zM86.9 4.9v34.3H28.2V4.9h58.7zM23.3 115.1V68.6h71v46.5h-71zm90.6 0H99.2V63.7H18.4v51.4H6.1V4.9h17.1v39.2h68.6V4.9h3.9l18.2 18.2v92z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M33.1 80.8h17.1c1.4 0 2.4-1.1 2.4-2.4S51.5 76 50.2 76H33.1c-1.4 0-2.4 1.1-2.4 2.4s1 2.4 2.4 2.4zM57.6 85.7H33.1c-1.4 0-2.4 1.1-2.4 2.4 0 1.4 1.1 2.4 2.4 2.4h24.5c1.4 0 2.4-1.1 2.4-2.4 0-1.3-1.1-2.4-2.4-2.4zM63.2 86.4c-.4.5-.7 1.1-.7 1.7 0 .6.3 1.3.7 1.7.5.4 1.1.7 1.7.7.6 0 1.3-.3 1.7-.7.4-.5.7-1.1.7-1.7 0-.6-.3-1.3-.7-1.7-.9-.9-2.5-.9-3.4 0zM82 9.8H67.3v24.5H82V9.8zm-4.9 19.6h-4.9V14.7h4.9v14.7z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "triangle",
      "viewBox": "0 0 138.6 120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M69.3 0l34.6 60 34.7 60H0l34.6-60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "triangle-down",
      "viewBox": "0 0 138.6 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M69.3 120L34.7 60 0 0h138.6L104 60l-34.7 60z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "refresh",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M118.4 27.7c-1.3-.5-2.7.2-3.2 1.5L111 40.4c-4.5-13.1-13.7-23.8-26.1-30-12.5-6.3-26.8-7.4-40.1-3C22.9 14.6 8.1 35.8 8.7 58.9c0 1.4 1.2 2.4 2.5 2.4h.1c1.4 0 2.5-1.2 2.4-2.6-.6-20.9 12.8-40 32.6-46.5 12.1-4 24.9-3 36.3 2.7 11.3 5.7 19.8 15.5 23.7 27.6.1.2.1.3.2.5l-11.8-4.3c-1.3-.5-2.7.2-3.2 1.5s.2 2.7 1.5 3.2l17.2 6.3c.3.1.6.2.9.2.4 0 .7-.1 1.1-.2.6-.3 1.1-.8 1.3-1.4l6.3-17.2c.5-1.5-.1-2.9-1.4-3.4zM109.6 44h.1-.1zM108.7 58.7c-1.4 0-2.5 1.2-2.4 2.6.6 20.9-12.8 40-32.6 46.5-24.9 8.2-51.8-5.4-60-30.3-.1-.2-.1-.3-.2-.5l11.8 4.3c1.3.5 2.7-.2 3.2-1.5s-.2-2.7-1.5-3.2L9.7 70.4c-1.3-.5-2.7.2-3.2 1.5L.2 89.1c-.5 1.3.2 2.7 1.5 3.2.3.1.6.2.9.2 1 0 2-.6 2.4-1.6l4-11.3c7.4 21.8 27.9 35.7 49.8 35.7 5.4 0 11-.9 16.4-2.6 21.9-7.2 36.8-28.4 36.1-51.4-.1-1.5-1.2-2.6-2.6-2.6zM10.3 76c.1 0 0 0 0 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "warning",
      "viewBox": "0 0 120 120"
    }
  }, [_c('path', {
    attrs: {
      "d": "M118.5 95.2L69.2 13.6c-1.9-3.2-5.5-5.2-9.2-5.2s-7.3 2-9.2 5.2L1.5 95.2c-2 3.3-2.1 7.5-.2 10.9 1.9 3.4 5.5 5.5 9.4 5.5h98.4c3.9 0 7.5-2.1 9.4-5.5 2-3.4 2-7.5 0-10.9zm-6.7 7.1c-.5.9-1.5 1.5-2.6 1.5H10.8c-1.1 0-2.1-.6-2.6-1.5s-.5-2.1 0-3l49.2-81.6c.5-.9 1.5-1.4 2.5-1.4s2 .6 2.5 1.4l49.2 81.6c.7.9.7 2 .2 3z"
    }
  }), _c('path', {
    attrs: {
      "d": "M60 40.5c-3 0-5.3 1.6-5.3 4.4 0 8.6 1 21 1 29.6 0 2.2 2 3.2 4.3 3.2 1.7 0 4.2-.9 4.2-3.2 0-8.6 1-21 1-29.6.1-2.8-2.3-4.4-5.2-4.4zM60 82.8c-3.2 0-5.6 2.5-5.6 5.6 0 3 2.4 5.6 5.6 5.6 3 0 5.5-2.6 5.5-5.6 0-3.1-2.5-5.6-5.5-5.6z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7a65170!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Icons.vue
// module id = 1815
// module chunks = 0